import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      // data-[state=unchecked]:bg-input used to leave the track invisible --
      // --input is a 91%-lightness near-white that disappears against this
      // app's equally pale surfaces (the same class of bug fixed on Checkbox
      // via border-primary). bg-muted is the closest token with real contrast
      // against both the light dialog/card backgrounds and the white thumb.
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-accent data-[state=unchecked]:bg-muted",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        // The thumb used to be bg-accent in both states -- identical to the
        // checked track's own fill, so a checked switch read as one solid
        // blob with no visible thumb at all. A neutral white thumb (like
        // every other pill toggle) stays legible against either track color.
        "pointer-events-none block h-5 w-5 rounded-full bg-popover shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
